import { datadogLogs } from "@datadog/browser-logs";

declare global {
  interface Window {
    DD_LOGS: any;
  }
}

export const cdnLogger = () => {
  if (window.DD_LOGS) {
    return window.DD_LOGS.logger;
  } else {
    console.log(
      "Datadog Logger not initialized before being called. Please double check datadog is being initialized if you wish to use this logger.."
    );
    return undefined;
  }
};

export const logger = () => {
  return datadogLogs.logger;
};
